/**
 * Icon name constants used throughout the application
 * This file prevents circular dependencies between LytIcon.jsx and optimizedIconRegistry.js
 */

export const ICON_NAMES = {
    ChevronDown: 'chevron-down',
    Layers: 'layers',
    Map: 'map',
    Globe: 'globe',
    X: 'x',
    Truck: 'truck',
    Bus: 'bus',
    Radio: 'radio',
    Key: 'key',
    Box: 'box',
    Square: 'square',
    PieChart: 'pie-chart',
    Grid: 'grid',
    GitPullRequest: 'git-pull-request',
    Users: 'users',
    Briefcase: 'briefcase',
    AlertCircle: 'alert-circle',
    Maximize2: 'maximize-2',
    Minimize2: 'minimize-2',
    Shuffle: 'shuffle',
    TrendingUp: 'trending-up',
    TrendingUpFill: 'trending-up-fill',
    TrafficLightsFill: 'traffic-lights-fill',
    File: 'file',
    Sun: 'sun',
    Moon: 'moon',
    LogOut: 'log-out',
    HelpCircle: 'help-circle',
    ChevronRight: 'chevron-right',
    ChevronLeft: 'chevron-left',
    Eye: 'eye',
    EyeOff: 'eye-off',
    Download: 'download',
    Bell: 'bell',
    Plus: 'plus',
    Edit: 'edit',
    Trash: 'trash',
    Search: 'search',
    ArrowLeft: 'arrow-left',
    Compass: 'compass',
    ZoomIn: 'zoom-in',
    ZoomOut: 'zoom-out',
    Satellite: 'satellite',
    VerticalDots: 'vertical-dots',
    // Sidebar icons
    SidebarAgency: 'sidebar-agency',
    SidebarCollapse: 'sidebar-collapse',
    SidebarDashboard: 'sidebar-dashboard',
    SidebarExpand: 'sidebar-expand',
    SidebarLiveMap: 'sidebar-live-map',
    SidebarSystemHealth: 'sidebar-system-health',
    SidebarRoutes: 'sidebar-routes',
    SidebarSignOut: 'sidebar-sign-out',
    SidebarTheme: 'sidebar-theme',
    SidebarUsersAndPermissions: 'sidebar-users-and-permissions',
    SidebarLytTeam: 'sidebar-lyt-team',
    // Toast icons
    ToastSuccess: 'toast-success',
    ToastError: 'toast-error',
    ToastWarning: 'toast-warning',
    ToastInfo: 'toast-info',
    // Utility icons
    CircleNotificationsFill: 'circle-notifications-fill',
    CircleInformationFill: 'circle-information-fill',
    // Logo icons
    CircleLogo: 'circle-logo',
    // Sidebar navigation icons (from lyt_icons)
    SidebarTeam: 'sidebar-team',
    SidebarRequests: 'sidebar-requests',
    SidebarAlerts: 'sidebar-alerts',
    SidebarCadAvl: 'sidebar-cad-avl',
    // Theme icons
    MoonFilled: 'moon-filled',
    SunFilled: 'sun-filled',
    // Action icons
    More: 'more',
    // User details icons
    PersonFill: 'person-fill',
    StackedEmailFill: 'stacked-email-fill',
    BriefcaseFill: 'briefcase-fill',
    AgencyFill: 'agency-fill',
    ViewingRightsFill: 'viewing-rights-fill',
    CalendarTodayFill: 'calendar-today-fill',
    CommentFill: 'comment-fill',
    // Alert/Warning icons
    BrightnessAlertFill: 'brightness-alert-fill',
    // Account icon
    UserAccount: 'user-account',
    // Map center icons
    CenterAgency: 'center-agency',
    CenterVehicle: 'center-vehicle',
};
